import { createStyles, makeStyles, Theme } from '@material-ui/core';

export const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    previousText: {
      textDecoration: 'line-through'
    },
    breakWord: {
      wordBreak: 'break-all'
    },
    arrow: {
      color: '#cccccc',
      transform: 'rotate(90deg)'
    },
    diffDetail: {
      backgroundColor: '#f5f5f5'
    }
  })
);
